import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import AOS from 'aos';
import Swiper from 'swiper/bundle';
import ma5menu from './plugins/menu/ma5-menu.min.js';
import Isotope from 'isotope-layout';

import 'swiper/css/bundle';
import './plugins/menu/ma5-menu.css';
import 'aos/dist/aos.css';
import '../styles/index.css';
import '../styles/fonts/ionicons/css/ionicons.css';
import '../styles/fonts/font-awesome/css/font-awesome.css';
import '../styles/animate.min.css';


(function ($) {
	'use strict';
	// $(document).ready(function () {
    //     setTimeout(function() {
    //         $('#preloader').addClass('hide');
    //     }, 1000);
	// });
	
	// Elements Animation
	AOS.init({
		disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  		duration: 1000, // values from 0 to 3000, with step 50ms
		offset: 40, // start animations a bit earlier in the viewport
		anchorPlacement: 'top-bottom',
		once: true, // whether animation should happen only once - while scrolling down
	})

	ma5menu({
		menu: '.main_menu',
		activeClass: 'current',
		footer: '.slide_navi',
		position: 'right',
		closeOnBodyClick: true
	});
	
	//$('a.ma5menu__toggle a').attr('aria-label', 'Menu Close');
	$('.ma5menu__home').attr('aria-label', 'Menu Home');
	$('a.ma5menu__toggle').attr('href', '#');

	
	$(window).on("scroll", function() {
		if($(window).scrollTop() > 50) {
			$(".header").addClass("sticky");
		} else {
			//remove the background property so it comes transparent again (defined in your css)
		   $(".header").removeClass("sticky");
		}
	});

	// Youtube
	// var $ytvideoTrigger = $(".ytplay_btn");
	// $ytvideoTrigger.on("click", function(evt) {  
	// 	$(".ytube_video").addClass("play");
	// 	$("#ytvideo")[0].src += "?autoplay=1";
	// });
	
	// Aside info bar
	$('.aside_open').click(function(e){
		e.preventDefault();
		$('.aside_info').css("left", "0px");
	});

	$('.aside_close').click(function(e){
		e.preventDefault();
		$('.aside_info').css("left", "-500px");
	});
	
	new Swiper('.swiper_one', {
		// Optional parameters
		direction: 'horizontal',
		autoHeight: true,
		loop:true, 
		autoplay: {
			delay: 7000,
		  },
		  effect: 'fade',
		  fadeEffect: {
			crossFade: true
		  },
		// If we need pagination
		pagination: {
		  el: '.swiper-pagination',
		},
	  
		// Navigation arrows
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
	  
		// And if we need scrollbar
		scrollbar: {
		  el: '.swiper-scrollbar',
		}, 
	  });

	 // Swiper: Slider // loop set to false to prevent infinite loop
// 	 new Swiper('.swiper_post .swiper', {
//         loop: true,
//         slidesPerView: 1,
//         spaceBetween: 0,
// 		// Navigation arrows
// 		navigation: {
// 		  nextEl: '.swiper-button-next',
// 		  prevEl: '.swiper-button-prev',
// 		},
// 		// If we need pagination
// 		pagination: {
// 		  el: '.swiper-pagination',
// 		  clickable: true
// 		},
//         breakpoints: {
//             600: {
//                 slidesPerView: 1,
//                 spaceBetween: 0
//             },
//             991: {
//                 slidesPerView: 2,
//                 spaceBetween: 30
//             },
//             1200: {
//                 slidesPerView: 3,
//                 spaceBetween: 15
//             }
//         }
//     });
// 	// Swiper: Slider
// 	new Swiper('.swiper_team .swiper', {
// 	   loop: true,
// 	   slidesPerView: 1,
// 	   spaceBetween: 0,
// 	   // If we need pagination
// 	   pagination: {
// 		 el: '.swiper-pagination',
// 		 clickable: true
// 	   },
// 	   breakpoints: {
// 		600: {
// 			slidesPerView: 1,
// 			spaceBetween: 0
// 		},
// 		991: {
// 			slidesPerView: 2,
// 			spaceBetween: 30
// 		},
// 		1200: {
// 			slidesPerView: 3,
// 			spaceBetween: 30
// 		}
// 	   }
//    });
	
// 	 // Swiper: Slider
// 	 new Swiper('.swiper_testimonial .swiper', {
//         loop: true,
//         slidesPerView: 1,
//         spaceBetween: 20,
// 		// Navigation arrows
// 		navigation: {
// 		  nextEl: '.swiper-button-next',
// 		  prevEl: '.swiper-button-prev',
// 		},
// 		pagination: {
// 			el: '.swiper-pagination',
// 			clickable: true
// 		},
//     });
	// accordion
	$(".accordion").on("click",".accordion_tab", function () {
		$(this).next().slideDown();
		$(".accordion_info").not($(this).next()).slideUp();
	});

	$(".accordion").on("click",".item", function () {
		$(this).addClass("active").siblings().removeClass("active");
	});



        // Isotope Portfolio
      //  var iso = $grid.data('isotope');
        //var $filterCount = $('.filter-count');
$(window).on('load', function(){
	AOS.refresh();
	// init Isotope
		$.fn.isotope = function (optionsOrMethod, ...args) {
			return this.each(function () {
			const $el = $(this);
			let iso = $el.data('isotope');
		
			if (!iso) {
				iso = new Isotope(this, optionsOrMethod);
				$el.data('isotope', iso);
			} else if (typeof optionsOrMethod === 'string') {
				iso[optionsOrMethod](...args);
			}
			});
		};
		var $grid = $('.grid').isotope({
			itemSelector: '.grid-item', 
			percentPosition: true,
			layoutMode: 'masonry',
			transformsEnabled: true,
			transitionDuration: "700ms",
			resize: true,
			fitWidth: true,
			columnWidth: '.grid-sizer',
		});

        // bind filter button click
        $('.filters-button-group .button').on( 'click', function() {
            var filterValue = $( this ).attr('data-filter');
            // use filterFn if matches value
            $grid.isotope({ filter: filterValue });
          
        });

        // change is-checked class on buttons
        $('.filters-button-group').each( function( i, buttonGroup ) {
            var $buttonGroup = $( buttonGroup );
            $buttonGroup.on( 'click', 'button', function() {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $( this ).addClass('is-checked');
            });
		});	
    });

	const EMAIL_URL = "https://95trn1yblb.execute-api.us-west-2.amazonaws.com/default/handleFormSubmissionContactBLO";	
	$('#appointment-success-section').hide();
	$('#appointment-failure-section').hide();
	$('#contact-form').submit(function(e){
		e.preventDefault();
		const values = $(this).serialize();
		$('#contact-submit-btn').val('Sending...');
		$('#contact-submit-btn').attr('disabled', true);
		fetch(EMAIL_URL+"?"+values)
		.then(response => response.json())
		.then(data => {
		  $('#appointment-form-section').hide();
		  $('#appointment-success-section').show();
		})
		.catch(error => {
		  //todo: handle error gracefully
			$('#appointment-form-section').hide();
			$('#appointment-failure-section').show();
		});


	});
 
	

})($);
	